<template>
  <div class="position-r box">
    <div class="index-banner" :style="{ backgroundImage: 'url(' + topBg.advUrl + ')' }" @click="goToUrl">
      <div class="f24 fw">欢迎使用</div>
      <div class="f24 fw"><span class="color-09">陪一会</span>共享{{devTypeName}}</div>
      <div class="pt5 flex-fs">
        <div class="mr8 photo-icon">
          <img :src="headPhoto" alt="" class="head-img" />
        </div>
        <span>{{ userName }}</span>
      </div>
    </div>
    <div class="flexJC p15" style="margin-top: -80px">
      <div class="content-box" v-show="isMz == true">
        <div class="flexJC alignItem text-over">
          <div class="flex-fs fw">
            <i class="icon-con icon_lb"></i>
            <span class="f16 color-3 mt-3">{{
              filterFun(cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.placeName)
            }}</span>
          </div>
          <div class="f16 color-9 pt10">
            <p>租用时间为以下时间段内开放</p>
            <p class="mt10" v-for="item in timerList">
              {{ item.startTime }}-{{ item.endTime }}
            </p>
          </div>
          <p class="pt10" v-show="timerList && timerList.length > 0 && timerList[0].overMoney">
            超时费用为：<span class="f18 color-09">{{
              timerList && timerList.length > 0
                ? timerList[0].overMoney
                  ? timerList[0].overMoney
                  : 0
                : 0
            }}</span>元
          </p>
          <div class="flex mt36">
            <button class="btn-lx btn-width btn-lx-width" @click="tautologyFun">
              重试
            </button>
          </div>
        </div>
      </div>
      <div class="" v-show="isMz == false">
        <!--租借-->
        <div class="content-box" v-show="isNormal == 1 && isBackBed == false">
          <div class="flexJC alignItem">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 mt-3">{{
                filterFun(cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.placeName)
              }}</span>
            </div>
            <h3 class="f20 color-3 pt10">
              可用{{devTypeName}}<span class="color-09">{{ number }}</span>台<span v-if="number == 0">请扫其它设备</span>
            </h3>
            <div class="bed-img pt10 pb15">
              <img src="../../static/images/icon_chuang.png" alt="" />
            </div>
            <div class="flexJC text-left">
              <div>
                <div style="float: left; width: 66%" align="left">
                  <h4 class="pb10">计费规则</h4>
                </div>
                <div style="float: left; width: 34%" align="right">
                  <a href="https://mp.weixin.qq.com/s/of5nX3s1TKvxMCyHfP1K6w" style="margin-right: -20px" class="btn btn-lx-big mb10 btn-width">关注公众号</a>
                </div>
              </div>

              <p v-if="cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.placeNo==='001031'" class="pt5 color-6 f12">
                包夜时间：（晚上21：00到第二天早上7：30）5元/次，非包夜时间：每天提供5分钟免费试用，超出免费时间后每小时收费1元，不足1小时按照1小时计算，日封顶20元。
              </p>

              <p v-else class="color-09 pt5">
                {{ cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.chargeMoney }}元 / {{
                  cabinetInfo && cabinetInfo.cabinet.chargeType === "HOUR"
                    ? (cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet && parseInt(cabinetInfo.cabinet.capaUnit)> 1 ? cabinetInfo.cabinet.capaUnit:'') + "小时"
                    : cabinetInfo && cabinetInfo.cabinet.chargeType === "DAY"
                    ? (cabinetInfo && cabinetInfo.cabinet && parseInt(cabinetInfo.cabinet.capaUnit)> 1 ? cabinetInfo.cabinet.capaUnit:'') + "天"
                    : (cabinetInfo && cabinetInfo.cabinet && parseInt(cabinetInfo.cabinet.capaUnit)> 1 ? cabinetInfo.cabinet.capaUnit:'') + "分钟"
                }}
                <span style="color:red;">租借{{ cabinetInfo && cabinetInfo.cabinet ? cabinetInfo.cabinet.freeTime:'' }}分钟内免费</span>，日封顶{{
                  cabinetInfo && cabinetInfo.cabinet 
                    ? cabinetInfo.cabinet.dayMoneyMax
                    : 0
                }}元，总封顶{{
                  cabinetInfo && cabinetInfo.cabinet ? cabinetInfo.cabinet.depositMoney : 0
                }}元
              </p>
              <p class="pt5 color-6 f12">支持免押租借</p>
            </div>
            <div class="mt36 flexJC alignItem" style="width: 80%">
              <a class="btn-lx btn-lx-big mb10" :disabled="number == 0 || isDisabled == true" :class=" number == 0 || isDisabled === true ? 'unSubmit' : 'btn-width'" v-if="isNormal == 1 && isBackBed == false" @click="postFreeOrder">立即租借</a>
              <a class="btn-lx btn-lx-big mb10 btn-width" @click="paySucceeded" v-if="isNormal != 1 || isBackBed && !isDisabled">已支付</a>
            </div>
            <div class="flexJC alignItem pb10" v-if="isNormal == 1 && isBackBed == false">
              <div class="flex-fs f12" style="height: 15px">
                <img class="zff-logo" src="../assets/zfflogo.png" />
                &nbsp;
                <div class="zff-text">微信支付分 | 550分及以上优享</div>
              </div>
            </div>
            <div class="flexJC alignItem pt20">
              <router-link tag="div" to="/agreement" class="f10 color-9 mr10">用户协议</router-link>
            </div>
          </div>
        </div>
        <!--归还  v-show="isBackBed == true"-->
        <div class="content-box" v-show="isBackBed == true">
          <div class="text-center fw">
            {{ list && list.placeName }}
          </div>
          <div class="pt10 f14 color-9">
            <div class="flexJC-sb pb10 border-b">
              <span>起租时间</span>
              <span>{{
                list && list.beginTime ? dateFormatter(list.beginTime) : ""
              }}</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计用时</span>
              <span>{{ list && list.useTime }}</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计正常计费</span>
              <span class="">{{
                  list && list.passNorMalMoney
                    ? list && list.passNorMalMoney
                    : "0"
                }}元</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计超时计费</span>
              <span class="">{{
                  list && list.passOverMoney ? list && list.passOverMoney : "0"
                }}元</span>
            </div>
            <div class="flexJC-sb pb10 border-b pt10">
              <span>累计总金额</span>
              <span class="">{{
                  list && list.passMoney ? list && list.passMoney : "0"
                }}元</span>
            </div>
            <div class="flexJC-sb pt10">
              <span class="f16 color-2 fw">退款预收金额(参考)：</span>
              <div class="color-38">
                <span class="f24 fw">
                  {{
                    parseInt(list && list.depositMoney) -
                      parseInt(list && list.passMoney) >
                    0
                      ? parseInt(list && list.depositMoney) -
                        parseInt(list && list.passMoney)
                      : "0"
                  }}
                </span>
                <span class="f16">元</span>
              </div>
            </div>
          </div>
        </div>
        <!--设备异常-->
        <div class="content-box" v-show="isNormal == 3 || isNormal == 5">
          <div class="flexJC alignItem text-over">
            <div class="flex-fs fw">
              <i class="icon-con icon_lb"></i>
              <span class="f16 color-3 text-over mt-3">{{
                cabinetInfo && cabinetInfo.cabinet ? cabinetInfo.cabinet.placeName:''
              }}</span>
            </div>
            <div class="pt18">
              <div class="noNormal">
                <img src="../../static/images/icon_noNarmal.png" alt="" />
                <a href="https://mp.weixin.qq.com/s/of5nX3s1TKvxMCyHfP1K6w" style="
                    margin-right: -20px;
                    width: 50%;
                    margin-bottom: 40%;
                    margin-left: 10px;
                    font-size: 14px;
                    padding: 10px;
                  " class="btn btn-lx-big mb10 btn-width">关注公众号</a>
              </div>
              <div class="f16 color-9 pt10">
                设备{{ isNormal == 5 ? "不在线" : "异常" }}
              </div>
              <div class="f16 color-9 pt10">
                <p>为您带来的不便我们深表歉意</p>
                <p class="mt5">请联系客服为您解决</p>
              </div>
            </div>
          </div>
          <div class="flex mt36">
            <a href="tel:400-688-1003" class="btn-lx btn-lx-width">联系客服</a>
          </div>
        </div>
        <!--没有设备-->
        <div class="content-box" v-show="isNormal == 4">
          <div class="flexJC alignItem text-over">
            <div class="pt18">
              <div class="noNormal">
                <img src="../../static/images/icon_noNarmal.png" alt="" />
              </div>
              <div class="f16 color-9 pt10">暂无设备</div>
            </div>
          </div>
        </div>
        <!--没有设备-->
        <div class="content-box" v-show="isNormal == 6">
          <div class="flexJC alignItem text-over">
            <div class="pt18">
              <div class="noNormal">
                <img src="../../static/images/icon_noNarmal.png" alt="" />
              </div>
              <div class="f16 color-9 pt10">当前轮椅不可租借，请换一台</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p15" v-show="isBackBed == false">
      <div class="banner">
        <mt-swipe :auto="8000">
          <mt-swipe-item>
            <div class="cabinet-box flexJC alignItem cabinet-content" @click="goToUrl">
              <div class="fw f20">
                每小时<span class="color-09">{{
                  cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.chargeMoney
                }}</span>元<span class="ml10">押金归还即退</span>
              </div>
              <div class="f14">
                预收金额<span class="f14 color-09">{{
                  cabinetInfo && cabinetInfo.cabinet && cabinetInfo.cabinet.depositMoney
                    ? cabinetInfo.cabinet.depositMoney
                    : 0
                }}</span>元<span>微信支付分550分以上扫码免押</span>
              </div>
            </div>
          </mt-swipe-item>
          <mt-swipe-item v-for="item in bannerList" :key="item.advNo">
            <a class="displsy-block banner-a" @click="goToNewUrl(item.outerUrl)"><img :src="item.advUrl" alt="" class="border-radius" /></a>
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </div>
    <div class="p15">
    </div>
    <!--弹框-->
    <div class="shade" v-show="hasMore">
      <div class="flexJC alignItem showLoading">
        <img src="../../static/images/Spinner_1.gif" alt="" class="icon_loading" />
      </div>
    </div>
    <div v-html="alipayWap" ref="alipayWap"></div>
    <audio id="audio_door_opened" src="https://www.aigehui028.com/static/mp/audios/wh-door-opened.mp3" width="1" height="1" preload></audio>

  </div>
</template>

<script>
import wxServ from "../service/wxServ";
import cache from "../service/cacheServ";
import cabinetServ from "../service/cabinetServ";
import mintUi from "../lib/mint-ui";
import moment from "moment";
import log from '../lib/log'

export default {
  data() {
    return {
      headPhoto: "/static/images/touxiang@2x.png",
      userName: "",
      isLoading: true,
      isNormal: null,
      cabinetInfo: null,
      number: null,
      qrCode: null,
      bedNo: null,
      hasMore: false,
      isBackBed: null, // 是否还床？
      list: null,
      wxId: null,
      giveBackList: null,
      alipayWap: null,
      isDisabled: false,
      bannerList: [],
      timerList: [],
      isFree: null,
      isMz: null,
      isYajin: false,
      checkedValue: true,
      topBg: {
        advUrl: "../../static/images/header-logo.png",
        outerUrl: null,
      },
      wsPayResult: "",
      getFreeLeaseOrderResult: ""
    };
  },
  computed: {
    devTypeName() {
      try {
        if (this.cabinetInfo.cabinet.cabinetNo.endsWith('-01')) return '陪护床'
        else
          if (this.cabinetInfo.cabinet.cabinetNo.endsWith('-03')) return '床头柜'
          else return '轮椅'
      } catch (err) {
        return '轮椅'
      }
    }
  },
  async created() {
    let qrCode = this.$route.query.qrcode;
    console.log("qrCode:" + this.$route.query.qrcode);
    this.qrCode = qrCode;
    this.bedNo = this.$route.query.bedNo;
    await this.getCabinetSta(qrCode);
    let userInfo = cache.get("user");
    if (userInfo && userInfo.openId) {
      this.userName = userInfo.customerName;
      this.headPhoto = userInfo.headImgUrl
        ? userInfo.headImgUrl
        : "/static/images/touxiang@2x.png";
      this.wxConfigJssdk(userInfo.openId);
      await this.getIsBedFun(userInfo.openId);
      this.wxId = userInfo.openId;
      await this.getCabinetSta(qrCode);
      this.getBannerList("HOME");
      this.getBannerList("HOMETOP");
    }
  },
  methods: {
    // 获取设备状态
    async getCabinetSta(qrCode) {
      // this.isLoading = false
      let res = await cabinetServ.getCabinetStatus(qrCode);

      log.info({ url: window.location.href, loc: 'openBusinessView', contents: { a: 'getCabinetStatus', contents: res }, qrcode: 1171 === +this.qrCode })

      if (res.code === "200") {
        if (!res.data) {
        } else {
          this.cabinetInfo = res.data;
          var bedNo = this.bedNo;
          cache.set("cabinetInfo", res.data, true);
          if (2 === +res.data.status) {
            if (!res.data.bedStructList) {
              this.isNormal = 5;
              return;
            }
            if (bedNo) {
              if (res.data.bedStructList[bedNo].status === 0 || res.data.doorStatus[bedNo] === 0) {
                this.isNormal = 6;
              }
            }
            // 设备正常
            this.isNormal = 1;
            var list = res.data.bedStructList;
            let newList = [];
            if (list.length > 0) {
              newList = list.filter((item) => item.status === 1);
            }
            this.number = newList.length;
          } else if (3 === +res.data.status) {
            // 设备离线
            this.isNormal = 5;
          } else if (res.data.status === "null") {
            // 设备离线
            this.isNormal = 5;
          } else {
            this.isNormal = 3;
          }
        }
      } else {
        this.isNormal = 4;
        mintUi.Toast({
          message: res.message,
          position: "bottom",
        });
      }
    },
    // 立即租借
    postBorrowBed() {
      let bedNO = this.bedNo;
      let customerWxId = cache.get("user").openId;
      let orderMoney = this.cabinetInfo.cabinet.depositMoney;
      let qrCode = this.qrCode;
      this.isDisabled = true;
      let _this = this;
      wxServ.prepareWx(bedNO, customerWxId, orderMoney, qrCode).then(
        function (res) {
          //调用封装的支付函数
          if (res.code === "200") {
            let data = res.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  _this.onBridgeReady(data),
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent(
                  "WeixinJSBridgeReady",
                  _this.onBridgeReady(data)
                );
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  _this.onBridgeReady(data)
                );
              }
            } else {
              _this.onBridgeReady(data);
            }
          } else {
            mintUi.Toast({
              message: res.message,
              position: "bottom",
            });
          }
        },
        function (value) {
          // failure
          _this.isDisabled = false;
        }
      );
    },
    // 查询是租借还是归还
    async getIsBedFun(id) {
      this.hasMore = true;
      let res = await cabinetServ.getCabinetIsZorF(id);

      log.info({ url: window.location.href, loc: 'getIsBedFun', contents: { ts: moment(new Date()).format("YYYY-MM-DD HH:mm:ss.SSS"), a: 'getCabinetIsZorF' }, qrcode: 1171 === +this.qrCode })
      this.hasMore = false;
      if (200 === +res.code) {
        if (res.data && res.data.length > 0) {
          // 归还
          this.isBackBed = true;

          try {
            if (2 === +this.cabinetInfo.cabinet.cabinetType || this.cabinetInfo.cabinet.cabinetNo.includes('-02')) {
              this.isBackBed = false;
            }
          } catch (error) {
            log.info({ url: window.location.href, loc: 'index.vue#getIsBedFun-setBackBed-error', contents: { cabinetInfo: this.cabinetInfo }, qrcode: true })
          }
          this.isMz = false;
          this.list = res.data[0];
        } else {
          // 租借
          this.isBackBed = false;
          this.isNormal = 1;
          this.getTimeList(this.qrCode);
        }

        log.info({ url: window.location.href, loc: 'getIsBedFun', contents: { a: 'getCabinetIsZorF', contents: { isBackBed: this.isBackBed, isMz: this.isMz, isNormal: this.isNormal } }, qrcode: 1171 === +this.qrCode })

      } else {
        mintUi.Toast({
          message: res.message,
          position: "bottom",
        });
      }

    },
    dateFormatter(time) {
      let datetime = time;
      if (datetime == undefined) {
        return "";
      }
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },
    // 立即归还
    postRepayBed() {
      let wxId = this.wxId;
      let orderNO = this.list.orderNo;
      let qrCode = this.qrCode;
      this.hasMore = true;
      cabinetServ.getRepayBed(wxId, orderNO).then((res) => {
        this.hasMore = false;
        if (res.code === "200") {
          this.$router.push({
            path: "/giveBackSuccess",
            query: { qrCode: qrCode, orderNo: orderNO },
          });
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    goToUrl() {
      if (this.topBg.outerUrl) {
        window.location.href = this.topBg.outerUrl;
      } else {
        window.location.href = "http://www.aigehui028.com/";
      }
    },
    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, //公众号名称，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: data.signType, //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            // 添加支付成功回调，在组件调用之后根据需求修改js逻辑
            setTimeout(function () {
              wxServ.getPayIsSuccess(data.orderNo).then((res) => {
                window.location.href =
                  window.location.origin +
                  "/#/openSuccess?qrCode=" +
                  this.qrCode +
                  "&orderNo=" +
                  data.orderNo;
              });
            }, 300);
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
          }
        }
      );
    },
    filterFun: function (value) {
      if (value && value.length > 13) {
        value = value.substring(0, 13) + "...";
      }
      return value;
    },
    // 获取广告
    getBannerList(position) {
      wxServ.getBanner(position).then((res) => {
        if (res.code === "200") {
          if (position == "HOME") {
            this.bannerList = res.data;
          } else if (position == "HOMETOP") {
            if (res.data && res.data.length > 0) {
              this.topBg = res.data[0];
            }
          }
        } else {
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    goToNewUrl(url) {
      if (url) {
        window.location.href = url;
      } else {
        return false;
      }
    },
    //获取租借时间段
    getTimeList(qrCode) {
      this.isLoading = true;
      cabinetServ.getOrderTimeList(qrCode).then((res) => {
        this.isLoading = false;
        if (res.code === "200") {
          this.timerList = res.data.timerList;
          if (res.data.timerList.length > 0) {
            var newTime = new Date();
            var nowTimes = this.getTimesTamp(
              res.data.nowDate.replace(/-/g, "/")
            );
            console.log(nowTimes);
            var yymmdd = this.formatDate(newTime, "yyyy/MM/dd");
            var list = res.data.timerList;
            var newList = [],
              iteml = {};
            list.forEach((item) => {
              iteml["startTime"] = this.getTimesTamp(
                yymmdd + " " + item.startTime + ":00"
              );
              iteml["endTime"] = this.getTimesTamp(
                yymmdd + " " + item.endTime + ":00"
              );
              if (item.startTime <= item.endTime) {
                iteml["endTime"] =
                  this.getTimesTamp(yymmdd + " " + item.endTime + ":00") +
                  24 * 60 * 60 * 1000;
              }
              newList.push(iteml);
            });
            console.log(newList);
            if (newList.length > 0) {
              newList.forEach((item) => {
                if (item.startTime <= nowTimes && nowTimes <= item.endTime) {
                  this.isMz = false;
                  // this.getCabinetSta(qrCode)
                } else {
                  this.isMz = true;
                }
              });
            }
          } else {
            this.isMz = false;
          }
        }
      });
    },
    formatDate(datetime, fmt = "yyyy/MM/dd hh:mm:ss") {
      let date = new Date();
      date.setTime(Date.parse(datetime));
      const o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        "S+": date.getMilliseconds(), // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
        );
      }
      for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
          ); //eslint-disable-line
        }
      }
      return fmt;
    },
    // 时间戳
    getTimesTamp(time) {
      return new Date(time).getTime();
    },
    tautologyFun() {
      this.getTimeList(this.qrCode);
    },
    //获取微信jssdk
    wxConfigJssdk(openId) {
      wxServ.configJssdk(openId);
    },
    compareVersion(v1, v2) {
      v1 = v1.split(".");
      v2 = v2.split(".");
      const len = Math.max(v1.length, v2.length);

      while (v1.length < len) {
        v1.push("0");
      }
      while (v2.length < len) {
        v2.push("0");
      }

      for (let i = 0; i < len; i++) {
        const num1 = parseInt(v1[i]);
        const num2 = parseInt(v2[i]);

        if (num1 > num2) {
          return 1;
        } else if (num1 < num2) {
          return -1;
        }
      }

      return 0;
    },
    changeInput(e) {
      console.log(e.target.checked);
      this.checkedValue = e.target.checked;
    },
    postFreeOrder() {
      // disabled
      if (this.number == 0 || this.isDisabled == true) return;

      var that = this;
      console.log(this.checkedValue);
      if (this.checkedValue == false) {
        mintUi.Toast({
          message: "请勾选同意《委托扣款授权书》",
          position: "bottom",
        });
        return;
      }
      this.isFree = true;
      this.isDisabled = true;
      wxServ.getFreeLeaseOrder(this.wxId, this.qrCode, this.bedNo).then((res) => {

        this.isFree = false;

        if (res.code == "200") {
          this.getFreeLeaseOrderResult = res.data;
          var data = res.data;
          wx.ready(function () {
            let wechatInfo = navigator.userAgent.match(
              /MicroMessenger\/([\d\.]+)/i
            );
            let wechatVersion = wechatInfo[1];
            wx.checkJsApi({
              jsApiList: ["openBusinessView"], // 需要检测的JS接口列表
              success: function (res) {
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"openBusinessView":true},"errMsg":"checkJsApi:ok"}

                if (res.checkResult.openBusinessView) {
                  wx.invoke(
                    "openBusinessView",
                    {
                      businessType: "wxpayScoreUse",
                      queryString: `mch_id=${data.mch_id}&package=${data.package}&timestamp=${data.timestamp}&nonce_str=${data.nonce_str}&sign_type=${data.sign_type}&sign=${data.sign}`,
                    },
                    function (res) {

                      // 从支付分返回时会执行这个回调函数
                      that.wxPayResult = res;

                      log.info({ url: window.location.href, loc: 'openBusinessView', contents: { qrCode: this.qrCode, openBusinessView: res }, qrcode: 1171 === +that.qrCode })
                      // 从支付分返回时会执行这个回调函数
                      // let samplePayResult = { 'loc': 'openBusinessView', 'contents': { 'openBusinessView': { 'extraData': '{"query_id":"AAQTnZoAAAABAAAAAADNR1Q_-k3hG5POjr1CYyAAAABcwQVtru-5k9MmEOZJ_Pv_Nq7Cw56dNKKN5EjZKnt5jbjJ0bdMUoiUK1mof_WSZOoUo2XSheodqBnxVQyxxNhdbE1qEnKV54NboKBBwKWCijchQD-m-UNKau_gxnBqgjjNCN-86UozKoZdCbFl_Pqtwr_wpUFlSBkyrV7-oa-MV1-vQlb2oBs-639XdOSnn9Pjo9OgxksNx-eCdwdLOI__rJXL","appid":"wxd8f3793ea3b935b8"}', 'err_msg': 'openBusinessView:ok', 'err_code': '0' } } }
                      that.isDisabled = false;
                      if (0 === +res.err_code) {
                        this.isYajin = false;
                        setTimeout(function () {
                          if (typeof res.extraData === typeof '') res.extraData = JSON.parse(res.extraData)
                          if (Boolean(res.extraData) && Boolean(res.extraData.query_id)) {
                            that.wxPayResult = res;
                            let subDir = '';
                            if (window.location.href.includes('testing-bedoa')) subDir = '/testing-bedoa';
                            else if (window.location.href.includes('testing')) {
                              subDir = '/testing'
                            }

                            let targetPage = 'paySuccess';

                            // https://tswap.aigehui028.com/#/Index?qrcode=1171&bedNo=1

                            let targetUrl = `${window.location.origin}${subDir}/#/${targetPage}?qrCode=${that.qrCode}&orderNo=${data.orderNo}&bedNo=${that.bedNo}`;

                            log.info({ url: window.location.href, loc: 'openBusinessView', contents: { loc: 'openBusinessViewSucceeded', contents: targetUrl }, qrcode: 1171 === +this.qrCode })

                            window.location.href = targetUrl;
                          }
                        }, 300);
                      } else {
                        // 返回失败
                        this.isYajin = true;
                      }
                    }
                  );
                }
              }
            });
          });
        } else {
          that.isDisabled = false;
          mintUi.Toast({
            message: res.message,
            position: "bottom",
          });
        }
      });
    },
    toUrlFun() {
      this.$router.push({ path: "/expenses", query: { qrCode: this.qrCode } });
    },
    paySucceeded() {
      let media = document.getElementById("audio_door_opened");
      // media.src = "https://www.aigehui028.com/static/mp/audios/wh-door-opened.aac"
      media.play();
      log.info({ url: window.location.href, loc: 'openBusinessView', contents: { wxPayResult: this.wxPayResult }, qrcode: 1171 === +this.qrCode })
      setTimeout(() => {
        if (typeof this.wxPayResult.extraData === typeof '') this.wxPayResult.extraData = JSON.parse(res.extraData)

        if (Boolean(this.wxPayResult.extraData.query_id)) {
          window.location.href =
            window.location.origin +
            "/#/openSuccess?qrCode=" +
            this.qrCode +
            "&orderNo=" +
            this.getFreeLeaseOrderResult.orderNo;
        }
      }, 2000);
    }
  },
  mounted() {
    // this.getCabinetSta(this.qrCode)
  },
};
</script>

<style lang="less" scoped>
@import "../less/_var.less";
@import "../less/index.less";

.banner-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 145px;
  z-index: -1;
}
.banner-position img {
  width: 100%;
  height: 100%;
}
.index-banner {
  padding: 26px 25px 0 25px;
  text-align: left;
  color: #fff;
  background-size: 100% 100%;
  height: 214px;
}
.pt5 {
  padding-top: 5px;
}
.loadingImg {
  width: 100px;
  height: 100px;
}
.loading-con {
  width: 70%;
  margin-left: -35%;
}
.photo-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
}
.photo-icon img {
  width: 100%;
  height: 100%;
}
.banner {
  height: 120px;
}
.banner img {
  width: 100%;
  height: 100%;
}
.userInfo {
  position: absolute;
  left: 90px;
  top: 15px;
  right: 16px;
}
.icon_lb {
  background: url("../../static/images/icon_position.png") no-repeat;
  background-size: 100% 100%;
  width: 14px;
  height: 16px;
}
.bed-img {
  width: 231px;
  height: 95px;
}
.bed-img img {
  // width: 100%;
  width: auto;
  height: 100%;
  margin: auto;
}
.icon-fy {
  background: url("../../static/images/icon_fy.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.mt-3 {
  margin-top: -2px;
}
.icon-sb {
  background: url("../../static/images/icon_sb.png") no-repeat;
  background-size: 100% 100%;
  width: 22px;
  height: 22px;
}
.icon_loading {
  width: 60px;
  height: 60px;
}
.head-img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
}
.unSubmit {
  background-color: #808080;
  color: #fff;
  border-color: #808080;
}
.zff-logo {
  height: 100%;
}
.zff-text {
  color: #666;
  font-family: PingFang;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue